const binding = { modules: {}, dataActions: {} };

    (binding.modules['defa-content-tile'] = {
        c: () => require('partner/modules/defa-content-tile/defa-content-tile.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'defa-content-tile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/defa-content-tile'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|defa-content-tile|defa-content-tile'] = {
                c: () => require('partner/modules/defa-content-tile/defa-content-tile.view.tsx'),
                cn: '__local__-__local__-defa-content-tile'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };